<div [class]="getCalendarContainer()">
  <div [class]="getCalendarCssClass()">
    <div [class]="getHeadlineMonth()">
      <div class="calendar-headline-month">
        @if(isTypeCalendarPadrao()) {
          <div id="inputGroup">
            <input id="dataCalendarioPadraoMobile"
            class="data-default-input show-mobile"
            [mask]="'00/00/0000'"
            [ngModel]="sincronizarDatePickerComInputMobile()"
            (keyup.enter)="trocarMesPorInputMobile($event.target.value)"
            />
            <input type="date" class="data-default-input hide-mobile" id="dataCalendarioPadrao"
            data-date-format="DD MMMM YYYY"
            [ngModel]="dt?.toISOString().split('T')[0]"
            [min]="LimiteMinData.toJSDate().toISOString().split('T')[0]"
            [max]="LimiteMaxData.toJSDate().toISOString().split('T')[0]"
            (keyup.enter)="trocarMesPorInputPadrao($event.target.value)"/>
            <svg
                id="iconeInputDataCalendario"
                class="data-default-icon"
                tabindex="0"
                (click)="simularCliqueInputDatePicker()"
                (keyup.enter)="simularCliqueInputDatePicker()"
                 width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                x="0"
                y="0"
                width="30"
                height="30"
                fill="white"/>
                <path d="M11.5 12.65H17.8889V18.4H11.5V12.65ZM20.4444 2.3H19.1667V0H16.6111V2.3H6.38889V0H3.83333V2.3H2.55556C1.15 2.3 0 3.335 0 4.6V20.7C0 21.965 1.15 23 2.55556 23H20.4444C21.85 23 23 21.965 23 20.7V4.6C23 3.335 21.85 2.3 20.4444 2.3ZM20.4444 4.6V6.9H2.55556V4.6H20.4444ZM2.55556 20.7V9.2H20.4444V20.7H2.55556Z" fill="#3C3C3B"/>
              </svg>
            <div [style]="customIconStyle">
              <input #inputDataCalendario type="date" class="data-input" id="dataCalendario" value="dd/MM/yyyy"
              [min]="LimiteMinData.toJSDate().toISOString().split('T')[0]"
              [max]="LimiteMaxData.toJSDate().toISOString().split('T')[0]"
              onkeypress="return false"
              tabindex="-1"
              [ngModel] ="dt?.toISOString().split('T')[0]"
              (ngModelChange)="trocarMesPorInputDatePicker($event)"/>
            </div>
          </div>
        } @else {
          <div [style]="customIconStyle">
            <input #inputDataCalendario type="date" class="data-input" id="dataCalendario" value="dd/MM/yyyy"
            data-date-format="DD MMMM YYYY"
            [min]="LimiteMinData.toJSDate().toISOString().split('T')[0]"
            [max]="LimiteMaxData.toJSDate().toISOString().split('T')[0]"
            onkeypress="return false"
            tabindex="-1"
            [ngModel] ="dt"
            (ngModelChange)="trocarMesPorInputDatePicker($event)"/>
            <div
            id="iconeInputDataCalendario"
            tabindex="0"
            (click)="simularCliqueInputDatePicker()"
            (keyup.enter)="simularCliqueInputDatePicker()"
            >
              <svg width="32" height="32" viewBox="0 0 55 55" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.042 25.2084H20.6253V29.7917H16.042V25.2084ZM16.042 34.375H20.6253V38.9584H16.042V34.375ZM25.2087 25.2084H29.792V29.7917H25.2087V25.2084ZM25.2087 34.375H29.792V38.9584H25.2087V34.375ZM34.3753 25.2084H38.9587V29.7917H34.3753V25.2084ZM34.3753 34.375H38.9587V38.9584H34.3753V34.375Z" fill="currentColor"/>
                <path d="M11.4583 50.4167H43.5417C46.0694 50.4167 48.125 48.3611 48.125 45.8334V13.75C48.125 11.2223 46.0694 9.16671 43.5417 9.16671H38.9583V4.58337H34.375V9.16671H20.625V4.58337H16.0417V9.16671H11.4583C8.93062 9.16671 6.875 11.2223 6.875 13.75V45.8334C6.875 48.3611 8.93062 50.4167 11.4583 50.4167ZM43.5417 18.3334L43.544 45.8334H11.4583V18.3334H43.5417Z" fill="currentColor"/>
              </svg>
            </div>
          </div>
          <div [class]="getMesAnoCor()"
            tabindex="0"
            (click)="simularCliqueInputDatePicker()"
            (keyup.enter)="simularCliqueInputDatePicker()">
            {{ primeiroDiaMesAtivo().monthLong }}
            {{ primeiroDiaMesAtivo().year }}
          </div>
        }
      </div>
      <div *ngIf="isTypeCalendarPadrao()" class="navegar-jornal-mobile-container">
        <button *ngIf="isTypeCalendarPadrao()" class="navegar-jornal-mobile" (click)="trocarMesPorInputMobile()"><i class="fa fa-search form-control-icon"></i>
        </button>
      </div>
      <div class="calendar-headline-controls-container">
        <button title="Mês Anterior"
        [style.background-color]="'transparent'"
        [disabled]="primeiroDiaMesAtivo().month <= LimiteMinData.month && primeiroDiaMesAtivo().year <= LimiteMinData.year"
        class="calendar-headline-control" tabindex="0" (click)="goToMesAnterior()" (keyup.space)="goToMesAnterior()">
          <i [style]="'color:' + getHeadlineControlsColor()" class="fas fa-chevron-left setas-navegacao-mes"></i>
        </button>
        <div [style]="'color:' + getHeadlineControlsColor()" class="calendar-headline-control calendar-headline-control-today" tabindex="0" (click)="goToHoje()" (keyup.space)="goToHoje()">
          {{textoNavegaDiaAtual}}
        </div>
        <button title="Mês posterior"
        [style.background-color]="'transparent'"
        [disabled]="primeiroDiaMesAtivo().month >= LimiteMaxData.month && primeiroDiaMesAtivo().year >= LimiteMaxData.year" class="calendar-headline-control" tabindex="0" (click)="goToMesSeguinte()" (keyup.space)="goToMesSeguinte()">
          <i [style]="'color:' + getHeadlineControlsColor()" class="fas fa-chevron-right setas-navegacao-mes"></i>
        </button>
      </div>
    </div>
    <div [class]="getHeadlineWeeks()">
      @for (dia of diasSemana(); track $index) {
      <div class="calendar-weeks-grid-cell">{{ dia }}</div>
      }
    </div>
    <div [class]="getGridCalendario()">
      @for (data of datasDoMes(); track $index) {
      <div
        tabindex="0"
        [class]="getCalendarCellClasses(data)"
        (click)="onDiaClicado(data)" (keyup.space)="onDiaClicado(data)">
          <div>
            <span style="position: relative;">
              {{ data.day }}
            </span>
            <div class="calendar-icon" style="flex-direction: row; display: flex;">
            @if(Cronogramas() && Cronogramas()[data.toISODate()]){
              @for(c of Cronogramas()[data.toISODate()]; track $index) {
                @switch(c){
                @case(0) {
                  <div class="description-icons" style="background-color: var(--cal-edicao-ordinaria); border-radius: 6px;"></div>
                }
                @case(1) {
                  <div class="description-icons" style="background-color: var(--cal-edicao-extra);"></div>
                }
                }
              }
            }
          </div>
          </div>
      </div>
      }
    </div>
  </div>
  <div *ngIf="ExibirLegendaPadrao" class="schedule">
    <div style="margin: auto; text-align: left;">
      <span class="descriptions">
        <div class="description-icons" style="background-color: var(--cal-edicao-ordinaria); border-radius: 6px;"></div> Edição Ordinária
      </span>
      <span class="descriptions">
        <div class="description-icons" style="background-color: var(--cal-edicao-extra);"></div> Edição extra
      </span>
      <span class="descriptions">
        <div class="description-icons" style="background-color: var(--cal-sem-publicacao);"></div> Sem publicação
      </span>
    </div>
  </div>
</div>
